import * as Sentry from '@sentry/react';
import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';

type TGlobalErrorBoundaryProps = {
	children: ReactNode;
};

const GlobalErrorBoundary = ({ children }: TGlobalErrorBoundaryProps) => {
	return (
		<ErrorBoundary
			FallbackComponent={ErrorFallback}
			onError={(error) => Sentry.captureException(error)}
		>
			{children}
		</ErrorBoundary>
	);
};

export default GlobalErrorBoundary;
